import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import LandingPage from './components/LandingPage';
import UploadingPage from "./components/UploadingPage";
import AuthEventHandler from "./components/AuthEventHandler/index.js";
import UserProfilePage from './components/UserProfilePage';
import MediaMap from "./components/MediaMap";
import ProjectDetailPage from "./components/ProjectDetailPage";
import LoginPage from './components/LoginPage';
import NotFoundPage from "./components/NotFoundPage";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";
import { HOME, UPLOADING, USER_PROFILE, PROJECT_DETAIL, LOGIN, DRONE_MAP, ADMIN, HELP } from "./Routes";
import AdminPage from "./components/AdminPage";
import Help from "./components/Help";
import './components/StoraEnsoComponents/assets/css/styles.css';

const AppWrapper = styled.div`
  background-color: ${({theme}) => theme.colors.bg_gray_light};
`;

const App = () => {
  return (
    <BrowserRouter>
      <AuthEventHandler />
      <ToastContainer position="top-center" />
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path={LOGIN} element={<LoginPage />} />
        <Route element={
          <PrivateRoute>
            <AppWrapper>
              <Layout />
            </AppWrapper>
          </PrivateRoute>
        }>
          <Route path={DRONE_MAP} element={<MediaMap />} />
          <Route path={PROJECT_DETAIL} element={<ProjectDetailPage />} />
          <Route path={UPLOADING} element={<UploadingPage />} />
          <Route path={USER_PROFILE} element={<UserProfilePage />} />
          <Route path={HOME} element={<LandingPage />} />
          <Route path={ADMIN} element={
            <PrivateRoute onlyAdmin>
              <AdminPage />
              </PrivateRoute>
            }
          />
          <Route path={HELP} element={<Help />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
